"use client";
import { jsx as o } from "react/jsx-runtime";
import { ikp as t } from "./factory.js";
import { forwardRef as I, useRef as h, useEffect as C } from "react";
import w from "react-textarea-autosize";
import * as u from "@radix-ui/react-select";
import * as R from "@radix-ui/react-checkbox";
import { useIntelligentForm as s } from "./intelligent-form/intelligent-form-provider.js";
import { IntelligentFormProvider as Hi } from "./intelligent-form/intelligent-form-provider.js";
import * as v from "@radix-ui/react-scroll-area";
import { BuiltInIconRenderer as S } from "../atoms/icons/built-in-icon-renderer.js";
import { maybeRender as b, dataAttr as a } from "../utils/misc.js";
import { Controller as L } from "react-hook-form";
import { IntelligentFormFieldProvider as V, useIntelligentFormField as _ } from "../providers/intelligent-form-field-provider.js";
import { CheckboxIcon as H } from "../atoms/icons/checkbox-icon.js";
import { useInkeepConfig as x } from "../providers/config-provider.js";
import { SourceItemProvider as E, useSourceItem as T } from "../providers/source-item-provider.js";
import { LinkWithQueryParams as D } from "../atoms/link.js";
import { Markdown as N } from "../atoms/markdown/index.js";
import { useComposedRefs as P } from "../utils/compose-refs.js";
import { composeEventHandlers as F } from "../utils/compose-event-handlers.js";
import { transformInkeepSource as q } from "../utils/transform-source/index.js";
const M = t("form", {
  _id: "intelligentForm__Root"
}), Ve = (i) => {
  const { onSubmit: e, ...n } = i, { handleSubmit: r } = s();
  return /* @__PURE__ */ o(M, { onSubmit: F(e, r), ...n });
}, He = t("h2", {
  _id: "intelligentForm__Heading",
  children: "Contact Support"
}), Ee = t("div", {
  _id: "intelligentForm__Content"
}), De = t(v.Root, {
  _id: "intelligentForm__Content__ScrollArea"
}), z = t(v.Viewport, {
  _id: "intelligentForm__Content__ScrollAreaViewport"
}), Ne = (i) => {
  const { children: e, ...n } = i;
  return /* @__PURE__ */ o(
    z,
    {
      children: (
        /* added this to fix an overflow issue see https://github.com/radix-ui/primitives/issues/926 */
        /* @__PURE__ */ o("div", { "data-part": "grid", style: { display: "grid" }, children: e })
      ),
      ...n
    }
  );
}, qe = t(
  v.ScrollAreaScrollbar,
  {
    _id: "intelligentForm__Content__ScrollAreaScrollbar"
  }
), Me = t(
  v.ScrollAreaThumb,
  {
    _id: "intelligentForm__Content__ScrollAreaThumb"
  }
), ze = t(v.Corner, {
  _id: "intelligentForm__Content__ScrollAreaCorner"
}), O = t("div", {
  _id: "intelligentForm__Success"
}), Oe = (i) => {
  const { children: e, ...n } = i, { isSubmitSuccessful: r } = s();
  return r ? /* @__PURE__ */ o(O, { ...n, children: e }) : null;
}, U = t(S, {
  _id: "intelligentForm__SuccessIcon"
}), Ue = (i) => {
  const {
    formSettings: { successView: e }
  } = s();
  return /* @__PURE__ */ o(
    U,
    {
      iconSettings: e.icon ?? { builtIn: "LuCircleCheck" },
      ...i
    }
  );
}, j = t("h2", {
  _id: "intelligentForm__SuccessHeading"
}), je = (i) => {
  const {
    formSettings: { successView: e }
  } = s();
  return /* @__PURE__ */ o(j, { children: e.heading, ...i });
}, Q = t("p", {
  _id: "intelligentForm__SuccessMessage"
}), Qe = (i) => {
  const {
    formSettings: { successView: e }
  } = s();
  return /* @__PURE__ */ o(Q, { children: e.message, ...i });
}, We = t("div", {
  _id: "intelligentForm__PrimaryForm"
}), W = t("div", {
  _id: "intelligentForm__PrimaryFormFields"
}), $ = t("p", {
  _id: "intelligentForm__PrimaryForm__Description"
}), $e = (i) => {
  const {
    formSettings: { primary: e }
  } = s();
  return e.description ? /* @__PURE__ */ o($, { children: e.description, ...i }) : null;
}, Ge = (i) => {
  const { children: e, ...n } = i, {
    formSettings: { primary: r }
  } = s();
  return /* @__PURE__ */ o(W, { children: b(e, r.fields), ...n });
}, G = t("button", {
  _id: "intelligentForm__PrimaryFormSubmit",
  type: "button",
  children: "Next"
}), Je = (i) => {
  const { onClick: e, ...n } = i, { submittedPrimaryForm: r, handleSubmitPrimaryForm: l } = s();
  return /* @__PURE__ */ o(
    G,
    {
      "data-submitted": a(r),
      onClick: F(e, l),
      ...n
    }
  );
}, J = t("div", {
  _id: "intelligentForm__Field"
}), Ke = (i) => {
  const { field: e, autoFocus: n, ...r } = i, { control: l, errors: c } = s();
  return /* @__PURE__ */ o(
    L,
    {
      name: e.name,
      control: l,
      rules: {
        required: e.isRequired ? `${e.label} is required.` : void 0
      },
      render: ({ field: m }) => {
        const d = m.value !== void 0 || e.inputType === "file";
        return /* @__PURE__ */ o(
          V,
          {
            "data-invalid": a(!!c[e.name]),
            field: e,
            fieldProps: m,
            autoFocus: n,
            children: d && /* @__PURE__ */ o(
              J,
              {
                "data-input-type": e.inputType,
                "data-hidden": a(e.isHidden),
                ...r
              }
            )
          }
        );
      }
    }
  );
}, K = t("label", {
  _id: "intelligentForm__FieldLabel"
}), Xe = (i) => {
  const { field: e } = _();
  return /* @__PURE__ */ o(
    K,
    {
      "data-required": a(e.isRequired),
      htmlFor: e.name,
      children: e.label,
      ...i
    }
  );
}, X = t("input", {
  _id: "intelligentForm__FieldText",
  type: "text"
}), k = I((i, e) => {
  const {
    field: n,
    error: r,
    fieldProps: {
      onChange: l,
      onBlur: c,
      ref: m,
      ...d
    },
    autoFocus: p
  } = _(), g = P(
    e,
    m
  );
  return /* @__PURE__ */ o(
    X,
    {
      asChild: n.inputType === "textarea",
      ref: g,
      id: n.name,
      autoFocus: p,
      placeholder: "placeholder" in n ? n.placeholder : void 0,
      "data-invalid": a(!!r),
      onChange: F(i.onChange, l),
      onBlur: F(i.onBlur, c),
      ...d,
      ...i,
      children: n.inputType === "textarea" ? /* @__PURE__ */ o(w, { minRows: 3, maxRows: 10 }) : null
    }
  );
}), Ye = t(k, {
  _id: "intelligentForm__FieldEmail",
  type: "email"
}), Y = t("input", {
  _id: "intelligentForm__FieldFile",
  type: "file",
  multiple: !0
}), Ze = (i) => {
  const {
    field: e,
    error: n,
    fieldProps: { value: r, onChange: l, onBlur: c, ...m },
    autoFocus: d
  } = _(), { onChange: p, onBlur: g, ...y } = i, f = (B) => {
    const A = B.target.files;
    l(A);
  };
  return /* @__PURE__ */ o(
    Y,
    {
      id: e.name,
      autoFocus: d,
      "data-value": r,
      "data-invalid": a(!!n),
      ...y,
      ...m,
      onChange: F(p, f),
      onBlur: F(g, c)
    }
  );
}, ei = t(
  k,
  {
    _id: "intelligentForm__FieldTextArea",
    type: "textarea",
    asChild: !0,
    children: /* @__PURE__ */ o(w, { rows: 1, maxRows: 8 })
  }
), Z = t(R.Root, {
  _id: "intelligentForm__FieldCheckbox"
}), ii = (i) => {
  const { field: e, error: n, fieldProps: r, autoFocus: l } = _(), { onCheckedChange: c, ...m } = i;
  return /* @__PURE__ */ o(
    Z,
    {
      id: e.name,
      name: e.name,
      autoFocus: l,
      "data-invalid": a(!!n),
      checked: r.value,
      onCheckedChange: F(c, r.onChange),
      ...m
    }
  );
}, ti = t(R.Indicator, {
  _id: "intelligentForm__FieldCheckboxIndicator",
  children: /* @__PURE__ */ o(H, {})
}), ee = t(u.Root, {
  _id: "intelligentForm__FieldSelect"
}), ni = (i) => {
  const { field: e, error: n, fieldProps: r } = _(), { onValueChange: l, ...c } = i;
  return /* @__PURE__ */ o(
    ee,
    {
      name: e.name,
      "data-invalid": a(!!n),
      value: r.value,
      onValueChange: F(l, r.onChange),
      ...c
    }
  );
}, ri = t(u.Trigger, {
  _id: "intelligentForm__FieldSelect__Trigger"
}), ie = t(u.Value, {
  _id: "intelligentForm__FieldSelect__Value"
}), oi = (i) => {
  const { field: e } = _();
  return /* @__PURE__ */ o(
    ie,
    {
      placeholder: "placeholder" in e ? e.placeholder : void 0,
      ...i
    }
  );
}, li = t(u.Icon, {
  _id: "intelligentForm__FieldSelect__Icon",
  asChild: !0,
  children: /* @__PURE__ */ o(S, { iconSettings: { builtIn: "LuChevronDown" } })
}), si = t(u.Content, {
  _id: "intelligentForm__FieldSelect__Content",
  position: "popper"
}), ci = t(u.Viewport, {
  _id: "intelligentForm__FieldSelect__Viewport"
}), mi = t(u.Item, {
  _id: "intelligentForm__FieldSelect__Item"
}), di = t(u.ItemText, {
  _id: "intelligentForm__FieldSelect__ItemText"
}), ai = t(
  u.ItemIndicator,
  {
    _id: "intelligentForm__FieldSelect__ItemIndicator",
    asChild: !0,
    children: /* @__PURE__ */ o(S, { iconSettings: { builtIn: "LuCheck" } })
  }
), te = t("span", {
  _id: "intelligentForm__FieldError"
}), Fi = (i) => {
  const { error: e } = _();
  return e ? /* @__PURE__ */ o(te, { children: e.message?.toString(), ...i }) : null;
}, ui = t("div", {
  _id: "intelligentForm__BotHeading"
}), _i = t(S, {
  _id: "intelligentForm__BotHeading__Icon",
  iconSettings: { builtIn: "LuSparkles" }
}), ne = t("div", {
  _id: "intelligentForm__BotHeading__Name"
}), gi = (i) => {
  const { baseSettings: e } = x(), { organizationDisplayName: n } = e ?? {}, {
    formSettings: { aiAssistantName: r }
  } = s();
  return /* @__PURE__ */ o(ne, { children: r ?? n, ...i });
}, re = t("div", {
  _id: "intelligentForm__Loading"
}), Si = I(({ ...i }, e) => {
  const { loading: n } = s(), r = h(null), l = P(e, r);
  return C(() => {
    n && r.current && r.current.scrollIntoView({
      behavior: "smooth",
      block: "nearest",
      inline: "nearest"
    });
  }, [n]), n ? /* @__PURE__ */ o(re, { ref: l, ...i }) : null;
}), oe = t("div", {
  _id: "intelligentForm__ConfidentResponse"
}), pi = I(({ ...i }, e) => {
  const { aiResponse: n, loading: r } = s(), l = h(null), c = P(e, l);
  return C(() => {
    !r && n.answerConfidence && l.current && l.current.scrollIntoView({
      behavior: "smooth",
      block: "nearest",
      inline: "nearest"
    });
  }, [r, n.answerConfidence]), n.answerConfidence ? /* @__PURE__ */ o(oe, { ref: c, ...i }) : null;
}), le = t(N, {
  _id: "intelligentForm__ConfidentAnswer"
}), vi = (i) => {
  const { aiResponse: e } = s();
  return /* @__PURE__ */ o(le, { shouldOpenLinksInNewTab: !0, children: e.answer, ...i });
}, se = t("button", {
  _id: "intelligentForm__ConfidentResponseButton",
  type: "button"
}), Ii = (i) => {
  const { onClick: e, ...n } = i, { showSecondaryFields: r, setShowSecondaryFields: l } = s(), c = () => {
    l(!0);
  };
  return /* @__PURE__ */ o(
    se,
    {
      "data-escalated": a(r),
      onClick: F(e, c),
      ...n
    }
  );
}, Pi = t(S, {
  _id: "intelligentForm__ConfidentResponseButton__Icon",
  iconSettings: { builtIn: "LuUser" }
}), fi = t("span", {
  _id: "intelligentForm__ConfidentResponseButton__Label",
  children: "Escalate to human"
}), ce = t("div", {
  _id: "intelligentForm__SecondaryForm"
}), hi = I(({ ...i }, e) => {
  const { showSecondaryFields: n } = s(), r = h(null), l = P(e, r);
  return C(() => {
    n && r.current && r.current.scrollIntoView({
      behavior: "smooth",
      block: "nearest",
      inline: "nearest"
    });
  }, [n]), n ? /* @__PURE__ */ o(ce, { ref: l, ...i }) : null;
}), me = t("p", {
  _id: "intelligentForm__SecondaryForm__Description"
}), Ci = (i) => {
  const {
    formSettings: { secondary: e },
    aiResponse: { answerConfidence: n }
  } = s();
  if (!e.description) return null;
  const r = typeof e.description == "string" ? e.description : (
    // If description is an object, use the confident description if the answer is confident
    n ? e.description.confident : e.description.default
  );
  return /* @__PURE__ */ o(me, { children: r, ...i });
}, de = t("div", {
  _id: "intelligentForm__SecondaryFormFields"
}), bi = (i) => {
  const { children: e, ...n } = i, {
    formSettings: { secondary: r }
  } = s();
  return /* @__PURE__ */ o(de, { children: b(e, r.fields), ...n });
}, ae = t("button", {
  _id: "intelligentForm__SecondaryFormSubmit",
  type: "submit",
  children: "Submit"
}), yi = (i) => {
  const { formSettings: e } = s(), { label: n } = e.buttons.submit;
  return /* @__PURE__ */ o(ae, { children: n ?? "Submit", ...i });
}, Fe = t("span", {
  _id: "intelligentForm__Error"
}), wi = (i) => {
  const { formError: e } = s();
  return e ? /* @__PURE__ */ o(Fe, { children: e.message, ...i }) : null;
}, Ri = t("div", {
  _id: "intelligentForm__Sources"
}), xi = t("p", {
  _id: "intelligentForm__SourcesCaption",
  children: "Here are the sources I considered:"
}), ue = t("div", {
  _id: "intelligentForm__SourcesList"
}), Ti = (i) => {
  const { children: e, ...n } = i, {
    baseSettings: { transformSource: r, organizationDisplayName: l }
  } = x(), {
    aiResponse: { recordsConsidered: c }
  } = s();
  if (!c) return null;
  const m = c.reduce((d, p) => {
    const g = q(p, "intelligentFormSource", {
      organizationDisplayName: l,
      transformSource: r
    });
    return d.some((f) => f.url === g.url) || d.push(g), d;
  }, []);
  return /* @__PURE__ */ o(ue, { children: b(e, m), ...n });
}, _e = t(D, {
  _id: "intelligentForm__Source"
}), ki = (i) => {
  const { source: e, ...n } = i;
  return /* @__PURE__ */ o(E, { source: { ...e, isExternal: !!e.shouldOpenInNewTab }, children: /* @__PURE__ */ o(
    _e,
    {
      "data-type": e.type,
      appendToUrl: e.appendToUrl,
      href: e.url,
      isExternal: e.shouldOpenInNewTab !== !1,
      ...n
    }
  ) });
}, ge = t(S, {
  _id: "intelligentForm__SourceIcon"
}), Bi = (i) => {
  const { source: e } = T();
  return /* @__PURE__ */ o(ge, { iconSettings: e.icon, "data-type": e.type, ...i });
}, Se = t("span", {
  _id: "intelligentForm__SourceTitle"
}), Ai = (i) => {
  const { source: e } = T();
  return /* @__PURE__ */ o(Se, { "data-type": e.type, children: e.title, ...i });
};
export {
  ui as BotHeading,
  _i as BotHeadingIcon,
  gi as BotHeadingName,
  vi as ConfidentAnswer,
  pi as ConfidentResponse,
  Ii as ConfidentResponseButton,
  Pi as ConfidentResponseButtonIcon,
  fi as ConfidentResponseButtonLabel,
  Ee as Content,
  De as ContentScrollArea,
  ze as ContentScrollAreaCorner,
  qe as ContentScrollAreaScrollbar,
  Me as ContentScrollAreaThumb,
  Ne as ContentScrollAreaViewport,
  wi as Error,
  Ke as FormField,
  ii as FormFieldCheckbox,
  ti as FormFieldCheckboxIndicator,
  Ye as FormFieldEmail,
  Fi as FormFieldError,
  Ze as FormFieldFile,
  Xe as FormFieldLabel,
  ni as FormFieldSelect,
  si as FormFieldSelectContent,
  li as FormFieldSelectIcon,
  mi as FormFieldSelectItem,
  ai as FormFieldSelectItemIndicator,
  di as FormFieldSelectItemText,
  ri as FormFieldSelectTrigger,
  oi as FormFieldSelectValue,
  ci as FormFieldSelectViewport,
  k as FormFieldText,
  ei as FormFieldTextArea,
  He as Heading,
  ui as IntelligentFormPrimitiveBotHeading,
  _i as IntelligentFormPrimitiveBotHeadingIcon,
  gi as IntelligentFormPrimitiveBotHeadingName,
  vi as IntelligentFormPrimitiveConfidentAnswer,
  pi as IntelligentFormPrimitiveConfidentResponse,
  Ii as IntelligentFormPrimitiveConfidentResponseButton,
  Pi as IntelligentFormPrimitiveConfidentResponseButtonIcon,
  fi as IntelligentFormPrimitiveConfidentResponseButtonLabel,
  Ee as IntelligentFormPrimitiveContent,
  De as IntelligentFormPrimitiveContentScrollArea,
  ze as IntelligentFormPrimitiveContentScrollAreaCorner,
  qe as IntelligentFormPrimitiveContentScrollAreaScrollbar,
  Me as IntelligentFormPrimitiveContentScrollAreaThumb,
  Ne as IntelligentFormPrimitiveContentScrollAreaViewport,
  wi as IntelligentFormPrimitiveFormError,
  Ke as IntelligentFormPrimitiveFormField,
  ii as IntelligentFormPrimitiveFormFieldCheckbox,
  ti as IntelligentFormPrimitiveFormFieldCheckboxIndicator,
  Ye as IntelligentFormPrimitiveFormFieldEmail,
  Fi as IntelligentFormPrimitiveFormFieldError,
  Ze as IntelligentFormPrimitiveFormFieldFile,
  Xe as IntelligentFormPrimitiveFormFieldLabel,
  ni as IntelligentFormPrimitiveFormFieldSelect,
  si as IntelligentFormPrimitiveFormFieldSelectContent,
  li as IntelligentFormPrimitiveFormFieldSelectIcon,
  mi as IntelligentFormPrimitiveFormFieldSelectItem,
  ai as IntelligentFormPrimitiveFormFieldSelectItemIndicator,
  di as IntelligentFormPrimitiveFormFieldSelectItemText,
  ri as IntelligentFormPrimitiveFormFieldSelectTrigger,
  oi as IntelligentFormPrimitiveFormFieldSelectValue,
  ci as IntelligentFormPrimitiveFormFieldSelectViewport,
  k as IntelligentFormPrimitiveFormFieldText,
  ei as IntelligentFormPrimitiveFormFieldTextArea,
  He as IntelligentFormPrimitiveHeading,
  Si as IntelligentFormPrimitiveLoading,
  We as IntelligentFormPrimitivePrimaryForm,
  $e as IntelligentFormPrimitivePrimaryFormDescription,
  Ge as IntelligentFormPrimitivePrimaryFormFields,
  Je as IntelligentFormPrimitivePrimaryFormSubmit,
  Ve as IntelligentFormPrimitiveRoot,
  hi as IntelligentFormPrimitiveSecondaryForm,
  Ci as IntelligentFormPrimitiveSecondaryFormDescription,
  bi as IntelligentFormPrimitiveSecondaryFormFields,
  yi as IntelligentFormPrimitiveSecondaryFormSubmit,
  ki as IntelligentFormPrimitiveSource,
  Bi as IntelligentFormPrimitiveSourceIcon,
  Ai as IntelligentFormPrimitiveSourceTitle,
  Ri as IntelligentFormPrimitiveSources,
  xi as IntelligentFormPrimitiveSourcesCaption,
  Ti as IntelligentFormPrimitiveSourcesList,
  Oe as IntelligentFormPrimitiveSuccess,
  je as IntelligentFormPrimitiveSuccessHeading,
  Ue as IntelligentFormPrimitiveSuccessIcon,
  Qe as IntelligentFormPrimitiveSuccessMessage,
  Si as Loading,
  We as PrimaryForm,
  $e as PrimaryFormDescription,
  Ge as PrimaryFormFields,
  Je as PrimaryFormSubmit,
  Hi as Provider,
  Ve as Root,
  hi as SecondaryForm,
  Ci as SecondaryFormDescription,
  bi as SecondaryFormFields,
  yi as SecondaryFormSubmit,
  ki as Source,
  Bi as SourceIcon,
  Ai as SourceTitle,
  Ri as Sources,
  xi as SourcesCaption,
  Ti as SourcesList,
  Oe as Success,
  je as SuccessHeading,
  Ue as SuccessIcon,
  Qe as SuccessMessage
};
